import Icon from './icon.vue';
export default Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/view-design/src/components/icon/index.js
// module id = 7tav
// module chunks = 100